import { AttributeCfg } from '../interface';
import Attribute from './base';

export default class Size extends Attribute {
  constructor(cfg: AttributeCfg) {
    super(cfg);
    this.type = 'size';
    this.names = ['size'];
  }
}
